module.exports = __webpack_public_path__ + "img/108.05526453.jpg";